const workHourTemplate = {id: -1, monday: [], tuesday: [], wednesday: [], thursday: [], friday: [], saturday: [], sunday: [], mode: 'open_in_worktime'}

export default workHourTemplate